export function secondsToHMS(seconds: number) {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Number((seconds % 60).toFixed(0))

  const pad = (num: number) => (num < 10 ? `0${num}` : `${num}`)

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
}
